<template>
  <div class="page-container">
    <div class="top-spacer"></div>
    <div class="header-image">
      <img src="@/images/projc.png" alt="项目图片" class="full-width-img" />
    </div>
    <div class="title-section">
      <h1>仓储设备</h1>
      <div class="title-divider"></div>
    </div>
    <section class="equipment-card">
      <div class="card-inner">
        <div class="text-content">
          <h2>存储</h2>
          <p class="desc-text">
            自动存取设备可以大幅度提高仓储效率，无论是重载货物自动化存取的托盘存取还是小件轻载货物的料箱存取，都可为客户提供一系列高效稳定的解决方案。
          </p>
          <p class="highlight-text">常见的存储设备有：</p>
          <p class="highlight-text">立体仓库、高位货架、miniload、穿梭车货架</p>
        </div>
        <div class="image-content">
          <img src="@/images/prokc01.png" alt="存储设备" class="content-img" />
        </div>
      </div>
    </section>

    <section class="equipment-card">
      <div class="card-inner reverse-layout">
        <div class="text-content">
          <h2>出入库</h2>
          <p class="desc-text">
            货物的拣选决定了出库效率的高低，是仓储作业高效运营的关键。通过整箱拣选和拆零拣选，大幅减少人工作业的同时，提高拣选正确率，降低仓储成本。
          </p>
          <p class="highlight-text">常见的存储设备有：</p>
          <p class="highlight-text">分拣机器人、机械臂、点数机</p>
        </div>
        <div class="image-content">
          <img src="@/images/prokc02.png" alt="出入库设备" class="content-img" />
        </div>
      </div>
    </section>

    <section class="equipment-card">
      <div class="card-inner">
        <div class="text-content">
          <h2>发货</h2>
          <p class="desc-text">
            自动发货设备拥有着适用性、优越性、可靠性及经济效益和人工成本方面的巨大优势。同时也是仓储流程里的重要一环，可根据客户行业特点定制解决方案。
          </p>
          <p class="highlight-text">常见的发货设备有：</p>
          <p class="highlight-text">开箱机、开袋机、贴单机、封箱机</p>
        </div>
        <div class="image-content">
          <img src="@/images/prokc03.png" alt="发货设备" class="content-img" />
        </div>
      </div>
    </section>

    <section class="equipment-card">
      <div class="card-inner reverse-layout">
        <div class="text-content">
          <h2>转运</h2>
          <p class="desc-text">
            无论是选择AGV、AMR还是输送系统，我们都将根据客户的产品类型，业务性质和吞吐量等综合因素，提供一套灵活稳定的解决方案。
          </p>
          <p class="highlight-text">常见的运输设备有：</p>
          <p class="highlight-text">DWS、自动叉车、AGV、爬坡机</p>
        </div>
        <div class="image-content">
          <img src="@/images/prokc04.png" alt="转运设备" class="content-img" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'WarehousingEquipment'
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  min-width: 320px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #ffffff;
}


.top-spacer {
  height: 80px;
  width: 100%;
}

.header-image {
  width: 100%;
  overflow: hidden;
}

.full-width-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}


.title-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 20px;
  padding: 0 20px;
}

.title-section h1 {
  font-size: 2.2rem;
  margin-bottom: 15px;
  color: #333;
}

.title-divider {
  background-color: #333;
  width: 50px;
  height: 6px;
  border-radius: 3px;
}

.equipment-card {
  margin: 30px auto;
  padding: 0 15px;
  max-width: 1400px;
}

.card-inner {
  display: flex;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  height: 380px;
  transition: transform 0.3s ease;
}

.card-inner:hover {
  transform: translateY(-3px);
}


.text-content, .image-content {
  width: 50%; 
  height: 100%;
  display: flex;
  flex-direction: column;
}

.text-content {
  background-color: rgba(229, 229, 229, 0.27);
  padding: 30px;
  justify-content: center;
}

.text-content h2 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #333;
  position: relative;
  padding-bottom: 10px;
}

.text-content h2::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 3px;
  background-color: #666;
}

.desc-text {
  font-size: 1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.highlight-text {
  font-size: 1rem;
  line-height: 1.8;
  color: #333;
  font-weight: 500;
  margin: 5px 0;
}


.image-content {
  overflow: hidden;
  position: relative;
}

.content-img {
  position: absolute; 
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.image-content:hover .content-img {
  transform: scale(1.03);
}


.reverse-layout {
  flex-direction: row-reverse;
}


@media (max-width: 768px) {
  .top-spacer {
    height: 40px;
  }

  .title-section {
    margin: 25px 0 15px;
  }

  .title-section h1 {
    font-size: 1.8rem;
  }

  .card-inner {
    flex-direction: column;
    height: auto; 
  }

  .text-content, .image-content {
    width: 100%;
  }

  .text-content {
    padding: 25px 20px;
    min-height: 300px; 
  }


  .image-content {
    height: 280px; 
  }

  .text-content h2 {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  .desc-text, .highlight-text {
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .card-inner {
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .equipment-card {
    margin: 20px auto;
  }
}


@media (min-width: 769px) and (max-width: 1024px) {
  .card-inner {
    height: 420px; 
  }
  
  .text-content {
    padding: 25px;
  }
  
  .text-content h2 {
    font-size: 1.6rem;
  }
  
  .desc-text, .highlight-text {
    font-size: 0.95rem;
    line-height: 1.7;
  }
}
</style>